"use strict";
/**
 * Full emoji list for picker (organized by category)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_EMOJIS = exports.EMOJI_CATEGORIES = void 0;
exports.EMOJI_CATEGORIES = {
    'Faces': [
        '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃', '🫠', '😉', '😊', '😇',
        '🥰', '😍', '🤩', '😘', '😗', '☺️', '😚', '😙', '🥲', '😋', '😛', '😜', '🤪', '😝',
        '🤑', '🤗', '🫡', '🤭', '🫢', '🫣', '🤫', '🤔', '🤨', '😐', '😑', '😶', '🫥',
        '😏', '😒', '🙄', '😬', '😮‍💨', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒', '🤕',
        '🥱', '🤐', '🥴', '🤢', '🤮', '🥵', '🥶', '😵', '😵‍💫', '🤯', '🤠', '🥳', '🥸', '😎',
        '🤓', '🧐', '😕', '🫤', '😟', '🙁', '😯', '😲', '😳', '🥺', '🥹', '😦', '😧', '😨',
        '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '😤', '😡',
        '😠', '🤬', '👿', '💀', '👻', '🤖', '😈', '🥷',
    ],
    'Hands': [
        '👍', '👎', '👊', '✊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✌️', '🤞',
        '🫰', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐️', '🖖', '👋',
        '🫱', '🫲', '🫳', '🫴', '🫷', '🫸', '👌', '🤌', '🤏', '✍️', '💪', '🦾', '🦵', '🦶',
        '👂', '👃', '🫀', '🫁', '🧠', '🦷', '🦴', '👀', '👁️', '💅', '🙆', '🙅', '🤷', '🙇',
    ],
    'Hearts': [
        '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❤️‍🔥', '❤️‍🩹', '❣️',
        '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '♥️',
    ],
    'Nature': [
        '🌈', '☀️', '🌤️', '⛅', '🌦️', '🌧️', '⛈️', '🌩️', '❄️', '☃️', '⛄', '🌊', '🔥', '🌪️',
        '🌸', '🌺', '🌻', '🌹', '🌷', '🌼', '🌱', '🌲', '🌳', '🌴', '🍀', '🍁', '🍂', '🍃',
        '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸',
        '🐵', '🐔', '🐧', '🐦', '🦆', '🦋', '🐝', '🐢', '🐬', '🐳', '🌙', '⭐', '🌟', '✨',
    ],
    'Celebration': [
        '🎉', '🎊', '🎈', '🎁', '🏆', '🥇', '🥈', '🥉', '🎂', '🍰', '🥂', '🍾', '🎇', '🎆',
        '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🪀', '🏓',
    ],
    'Objects': [
        '✨', '💫', '⭐', '🌟', '💥', '⚡', '✅', '❌', '❗', '‼️', '⁉️', '❓', '❔', '💯',
        '🔴', '🟠', '🟡', '🟢', '🔵', '🟣', '🍚', '🧅', '🥕', '🍅', '🧄', '🥦', '🍗', '🍕',
    ],
};
exports.ALL_EMOJIS = Array.from(new Set(Object.values(exports.EMOJI_CATEGORIES).flat()));
